export default __webpack_public_path__ + "static/13_hue-7b5a492dd8de558d8bc41073264f9697.png";